import React from "react";
import { useTranslation } from "react-i18next";
import "./SeccionExtra.css";

export default function SeccionExtra() {
  const { t } = useTranslation();

  return (
    <div className="seccion-extra">
      <div className="seccion-extra-texto">
        <p>{t("seccion_extra.text")}</p>
      </div>
      <div className="seccion-extra-imagen">
        <img
          src="/postulate.webp"
          alt={t("seccion_extra.title")}
          className="imagen-redonda"
        />
        <h2>{t("seccion_extra.title")}</h2>
      </div>
    </div>
  );
}
